__turbopack_context__.v({
  "app_light_theme": "product-specs-panel-module-scss-module__aM4XHa__app_light_theme",
  "productSpecsPanel": "product-specs-panel-module-scss-module__aM4XHa__productSpecsPanel",
});
